import { render, staticRenderFns } from "./Concorrente.vue?vue&type=template&id=176d59c3"
import script from "./Concorrente.vue?vue&type=script&lang=js"
export * from "./Concorrente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports